const UseId = () => {
    return (
        <div className="demo-container">
            <div className="demo-box">
                <code>Used for generating ids for html elements with concern to aria role for Accessibility.<br/><br/> Check more at : https://beta.reactjs.org/reference/react/useId</code>
            </div>
        </div>
    )
}

export default UseId